/**
 *  weiboCommentModule
 *
 * Description 微博评论
 * Author: Qian.qianchen 2018-11-22
 */
'use strict';
angular.module('weiboCommentModule', ['weiboCommentRouterModule']).controller('weiboCommentCtrl', [
    '$scope',
    '$stateParams',
    '$q',
    'trsHttpService',
    'modalDialog',
    '$validation',
    '$timeout',
    'editcenterRightsService',
    function($scope, $stateParams, $q, trsHttpService, modalDialog, $validation, $timeout, editcenterRightsService) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 15,
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.status = {
                selectTab: 'recieved',
                recievedParams: {
                    serviceid: 'wcm61_scmcomment',
                    methodname: 'queryCommentsToMeToJson',
                    PageIndex: $scope.page.CURRPAGE,
                    PageSize: $scope.page.PAGESIZE,
                    AccountId: $stateParams.wbchannelid,
                },
                launchParams: {
                    serviceid: 'wcm61_scmcomment',
                    methodname: 'queryCommentsByMeToJson',
                    PageIndex: $scope.page.CURRPAGE,
                    PageSize: $scope.page.PAGESIZE,
                    AccountId: $stateParams.wbchannelid,
                },
                user: {},
                copyCurrPage: 1,
                hasRight: true,
            };
            $scope.data = {
                items: [],
            };
        }

        function initData() {
            initBtnRights();
            requestData().then(function() {
                return getWeiboUser();
            });
        }

        /**
         * [initBtnRights description] 初始化权限
         * @return {[type]} [description]
         */
        function initBtnRights() {
            editcenterRightsService.initWeiboListBtn('microblog.fachudepinglun', $stateParams.wbchannelid).then(function(rights) {
                $scope.status.btnLaunchRights = rights;
            });
            editcenterRightsService.initWeiboListBtn('microblog.shoudaodepinglun', $stateParams.wbchannelid).then(function(rights) {
                $scope.status.btnRecievedRights = rights;
            });
        }
        
        /**
         * [requestData description] 获取数据
         * @return {[type]} [description]
         */
        function requestData() {
            var deferred = $q.defer();
            var params;
            if ($scope.status.selectTab == 'recieved') {
                params = $scope.status.recievedParams;
            } else {
                params = $scope.status.launchParams;
            }

            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post', true).then(
                function(data) {
                    $scope.status.hasRight = true;
                    $scope.data.items = data.result;
                    if (!!data.pageinfo) {
                        $scope.page.CURRPAGE = data.pageinfo.indexPage;
                        $scope.page.PAGESIZE = data.pageinfo.pageSize;
                        $scope.page.ITEMCOUNT = data.pageinfo.totalNum;
                        $scope.page.PAGECOUNT = data.pageinfo.pageCount;
                    } else {
                        $scope.page.ITEMCOUNT = '0';
                    }
                    deferred.resolve(data);
                },
                function(data) {
                    $scope.status.hasRight = false;
                }
            );
            return deferred.promise;
        }

        /**
         * [getWeiboUser description] 获取当前登录的微博账户信息
         * @return {[type]} [description]
         */
        function getWeiboUser() {
            var deferred = $q.defer();
            var params = {
                serviceid: 'wcm61_scmaccount',
                methodname: 'findByIdToJson',
                ObjectId: $stateParams.wbchannelid,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.status.user = data;
                deferred.resolve(data);
            });
            return deferred.promise;
        }

        /**
         * [pageChanged description] 换页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            if ($scope.status.selectTab == 'recieved') {
                $scope.status.recievedParams.PageIndex = $scope.page.CURRPAGE;
            } else {
                $scope.status.launchParams.PageIndex = $scope.page.CURRPAGE;
            }

            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };

        /**
         * [headPicload description] 头像未能正常显示时显示默认头像
         * @param  {[object]} item [description] 微博账号对象
         * @return {[type]}      [description]
         */
        $scope.headPicload = function(item, attr) {
            var imgObj = new Image();
            if (attr == 'user.head') {
                imgObj.src = item.user.head;
            } else if (attr == 'head') {
                imgObj.src = item.HEADPIC;
            }

            imgObj.onload = function() {
                item.picUrl = imgObj.src;
            };
            imgObj.onerror = function() {
                item.picUrl = './images/user_icon.jpg';
            };
        };

        /**
         * [clickTab description] tab选择切换
         * @param  {[String]} tab [description]tab名称
         * @return {[type]}     [description]
         */
        $scope.clickTab = function(tab) {
            $scope.status.selectTab = tab;
            requestData();
        };

        /**
         * [itemReplyInit description] 微博评论对象回复状态初始化
         * @param  {[object]} item [description] 微博评论对象
         * @return {[type]}      [description]
         */
        $scope.itemReplyInit = function(item) {
            item.replyShow = false;
            item.emojiShow = false;
            item.replyContent = '';
        };

        /**
         * [replyToggle description] 微博评论回复
         * @param  {[object]} item [description] 收到的微博评论item
         * @return {[type]}      [description]
         */
        $scope.replyToggle = function(item) {
            item.replyContent = '';
            item.replyShow = !item.replyShow;
        };

        /**
         * [deleteComment description] 微博评论删除
         * @param  {[object]} item [description] 发起的微博评论对象
         * @return {[type]}      [description]
         */
        $scope.deleteComment = function(item) {
            modalDialog.confirmModal('删除', '是否确认删除此微博', function() {
                var params = {
                    serviceid: 'wcm61_scmcomment',
                    methodname: 'destroyCommentToJson',
                    CommentId: item.commentId,
                    AccountId: $stateParams.wbchannelid,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    modalDialog.alertType('删除成功', '', 'success', false);
                    requestData();
                });
            });
        };

        /**
         * [replySubmit description] 微博评论回复
         * @param  {[object]} item [description] 评论item
         * @return {[type]}      [description]
         */
        $scope.replySubmit = function(item, index) {
            var formName = 'replyContent_' + (index + ($scope.page.CURRPAGE - 1) * $scope.page.PAGESIZE);
            $scope.replyForm.$pending = {};
            $validation.validate($scope.replyForm[formName]).success(function() {
                var params = {
                    serviceid: 'wcm61_scmcomment',
                    methodname: 'createCommentToJson',
                    MicroContentId: item.replyMicroContent.id,
                    AccountId: $stateParams.wbchannelid,
                    isReplyComment: true,
                    Content: item.replyContent,
                    modulename: 'microblog.shoudaodepinglun.huifu',
                    CommentId: item.commentId,
                };
                $scope.loadingPromise = trsHttpService.httpServer('/wcm/rbcenter.do', params, 'post').then(function(data) {
                    modalDialog.alertType('评论成功', '', 'success', false);
                    item.replyContent = '';
                    item.replyShow = false;
                });
            });
        };
        $scope.addEmoji = function(item, dataObj) {
            var dom = document.getElementById('text_content');
            var startPos = dom.selectionStart;
            var endPos = dom.selectionEnd;
            dataObj.replyContent =
                dataObj.replyContent.substring(0, startPos) + item.value + dataObj.replyContent.substring(endPos, dataObj.replyContent.length);

            $timeout(function() {
                dom.focus();
                dom.selectionStart = dom.selectionEnd = startPos + item.value.length;
            });
        };
    },
]);
